import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import apiCall from "../../utils/apiCall";
import showNotification from "../../utils/notification";
import styles from "./main.module.scss";

interface LogoutButtonProps {
  handleClose: () => void;
}

interface LogoutPayload {
  UserId: string;
  UserToken: string;
}

interface LogoutResponse {
  Value: Value;
  Formatters: any[];
  ContentTypes: any[];
  DeclaredType?: any;
  StatusCode: number;
}

interface Value {
  Message: string;
  StatusCode: number;
  Content: Content;
  Success: boolean;
}

interface Content {
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Email: string;
  Roles?: any;
  MobileNumber: string;
  ExpirationTime: string;
  LastLoginDate?: any;
  PwdExpiryDate: string;
  PwdChangedDate?: any;
  ForcePwdChange: boolean;
  LastModified?: any;
  ModifiedBy?: any;
  CreatedDate: string;
  CreatedBy: string;
  IsDeleted: boolean;
  IsActive: boolean;
  RoleId: string;
  ConfirmationLinkExpireDate: string;
  UserToken: string;
  Id: string;
  UserName: string;
  NormalizedUserName: string;
  NormalizedEmail?: any;
  EmailConfirmed: boolean;
  PasswordHash: string;
  SecurityStamp: string;
  ConcurrencyStamp: string;
  PhoneNumber: string;
  PhoneNumberConfirmed: boolean;
  TwoFactorEnabled: boolean;
  LockoutEnd?: any;
  LockoutEnabled: boolean;
  AccessFailedCount: number;
}

const Main: React.FC<LogoutButtonProps> = ({ handleClose }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const queryParams = `${user.userId}${user.userToken}`;

  const logout = async () => {
    return (
      await apiCall().get(
        `/Account/LogOut?UserId=${user?.userId}&UserToken=${user?.userToken}`
      )
    )?.data as LogoutResponse;
  };
  const { isError, error, refetch } = useQuery(
    ["logout", queryParams],
    logout,
    {
      enabled: false,
    }
  );

  const logoutError = error as AxiosError;
  const logoutErrorMessage = logoutError?.message;

  const logoutHandler = () => {
    refetch();
    localStorage.removeItem("result-manager-auth");
    localStorage.removeItem("result-manager-roles");
    localStorage.removeItem("session-details");
    navigate("/");
  };

  isError && showNotification({ message: logoutErrorMessage, type: "error" });

  return (
    <div>
      <div className={styles.textContainer}>
        <p>Are you sure you want to log out?</p>
      </div>

      <div className={styles.btnContainer}>
        <button className={styles.closeButton} onClick={handleClose}>
          Cancel
        </button>
        <button className={styles.logoutButton} onClick={logoutHandler}>
          Log out
        </button>
      </div>
    </div>
  );
};

export default Main;
